import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B3B7BF",
      d: "M7.967 12q.35 0 .592-.242a.8.8 0 0 0 .24-.591q0-.35-.24-.592a.8.8 0 0 0-.592-.241q-.35 0-.592.242a.8.8 0 0 0-.242.59q0 .35.242.593a.8.8 0 0 0 .592.241M8 14.667a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 1.86 10.6 6.5 6.5 0 0 1 1.333 8q0-1.383.526-2.6a6.7 6.7 0 0 1 1.424-2.117q.9-.9 2.117-1.424A6.5 6.5 0 0 1 8 1.333q1.383 0 2.6.526 1.217.525 2.117 1.425T14.142 5.4t.525 2.6-.526 2.6a6.75 6.75 0 0 1-1.424 2.117q-.9.9-2.117 1.425a6.5 6.5 0 0 1-2.6.525m0-1.333q2.233 0 3.783-1.55T13.333 8t-1.55-3.783T8 2.667t-3.783 1.55T2.667 8t1.55 3.784T8 13.334m.067-8.2q.416 0 .725.266.309.267.308.667 0 .365-.225.65-.226.284-.508.533-.383.333-.675.734a1.5 1.5 0 0 0-.292.9q0 .233.175.391a.6.6 0 0 0 .408.159.6.6 0 0 0 .426-.167.76.76 0 0 0 .224-.417 1.34 1.34 0 0 1 .3-.625 6 6 0 0 1 .5-.525q.383-.366.659-.8a1.76 1.76 0 0 0 .275-.966q0-.85-.692-1.392A2.54 2.54 0 0 0 8.067 4q-.634 0-1.208.267-.575.267-.876.816a.6.6 0 0 0-.075.426q.041.225.225.341a.664.664 0 0 0 .9-.2q.183-.25.459-.383.275-.134.575-.134"
    }, null, -1)
  ]))]))
}
export default { render: render }